<template>
  <v-container>
    <v-layout align-center justify-space-around wrap>
      <v-img height="250" contain :src="require('../assets/washi.png')">
        <!-- <v-layout pa-2 column fill-height class="lightbox">
          <v-spacer></v-spacer>
          <v-flex shrink>
            <div class="subheading ">{{name}}</div>
            <div class="body-1">{{nickname}}</div>
          </v-flex>
        </v-layout> -->
      </v-img>
    </v-layout>
    <!-- <div class="text-md-center">
      name: {{name}}
    </div> -->
    <div class="text-md-center">
      {{nickname}}
    </div>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      name: "関根裕太",
      nickname: "のび"
    })
  }
</script>

<style>

</style>